export default[
    {
        path: '/dataList/yuanYuanAchievement',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '门店业绩',
            authLogin: true
        }
    }
]